// Internal error types: not exported beyond this module
export class MissingServiceError extends Error {
    constructor(key) {
        super(`No binding function, nor existing resolved instance for service: ${String(key)} - returning undefined at runtime`);
    }
}
export class InvalidBindingError extends Error {
    constructor(key) {
        super(`Invalid binding for service: ${String(key)}`);
    }
}
/**
 * You'll get this error when you have a chain of dependencies that form a loop
 *
 * Break the chain of dependencies somewhere that makes sense (the rest of the links will usually remain)
 */
export class ResolutionCycleError extends Error {
    constructor(key, resolving) {
        const index = resolving.indexOf(key);
        if (index !== -1) {
            resolving = resolving.slice(index);
        }
        super(`Cycle in chain of dependencies, while resolving service: ${key} <- ${resolving.reverse().join(" <- ")}`);
    }
}
//# sourceMappingURL=error.js.map